import React, { useState, useEffect } from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="footer-column">
            <h4>Về chúng tôi</h4>
            <p>Pellentesque posuere orci lobortis scelerisque blandit. Donec id tellus lacinia an, tincidunt risus ac, consequat velit. Donec id tellus lacinia an, tincidunt risus ac, consequat velit</p>
            <a href="#about" className="know-more">Tìm hiểu thêm</a>
          </div>
          <div className="footer-column">
            <h4>Trợ giúp</h4>
            <ul>
              <li><a href="#search">Tìm kiếm</a></li>
              <li><a href="#help">Trợ giúp</a></li>
              <li><a href="#information">Thông tin</a></li>
              <li><a href="#privacy">Chính sách bảo mật</a></li>
              <li><a href="#shipping">Chi tiết vận chuyển</a></li>
            </ul>
          </div>
          <div className="footer-column">
            <h4>Hỗ trợ</h4>
            <ul>
              <li><a href="#contact">Liên hệ chúng tôi</a></li>
              <li><a href="#about">Về chúng tôi</a></li>
              <li><a href="#careers">Tuyển dụng</a></li>
              <li><a href="#refund">Hoàn tiền & Đổi trả</a></li>
              <li><a href="#deliveries">Giao hàng</a></li>
            </ul>
          </div>
          <div className="footer-column">
            <h4>Thông tin</h4>
            <ul>
              <li><a href="#search-terms">Điều khoản tìm kiếm</a></li>
              <li><a href="#advanced">Nâng cao</a></li>
              <li><a href="#faq">Trợ giúp & Câu hỏi thường gặp</a></li>
              <li><a href="https://www.google.com/maps/place/M%C6%A1+Nails/@10.8422427,106.6589741,16.75z/data=!4m6!3m5!1s0x317529004f2ef75d:0x2df16174e77a8259!8m2!3d10.8456239!4d106.6619725!16s%2Fg%2F11ypsfbglx?entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">Vị trí cửa hàng</a></li>
              <li><a href="#orders">Đơn hàng & Đổi trả</a></li>
            </ul>
          </div>
          <div className="footer-column">
            <h4>Liên hệ chúng tôi</h4>
            <ul className="contact-info">
              <li><i className="fas fa-map-marker-alt"></i> 89, Đường Số 1, Phường Thông Tây Hội, Gò Vấp</li>
              <li><i className="fas fa-phone"></i> 0702481111</li>
              <li><i className="fas fa-envelope"></i> trantrungg7@gmail.com</li>
            </ul>
            <div className="payment-methods">
              <i className="fab fa-cc-visa"></i>
              <i className="fab fa-cc-mastercard"></i>
              <i className="fab fa-cc-amex"></i>
              <i className="fab fa-cc-paypal"></i>
              <i className="fab fa-cc-diners-club"></i>
              <i className="fab fa-cc-discover"></i>
            </div>
            <div className="social-links">
              <a href="#facebook"><i className="fab fa-facebook-f"></i></a>
              <a href="#pinterest"><i className="fab fa-pinterest"></i></a>
              <a href="#instagram"><i className="fab fa-instagram"></i></a>
            </div>
          </div>
        </div>
        <div className="footer-divider"></div>
        <div className="footer-bottom">
          <p className="copyright">&copy; 2025 Mơ Nails Design Themes</p>
          <div className="footer-bottom-links">
            <a href="#search">Tìm kiếm</a>
            <a href="#help">Trợ giúp</a>
            <a href="#information">Thông tin</a>
            <a href="#privacy">Chính sách bảo mật</a>
            <a href="#shipping">Chi tiết vận chuyển</a>
          </div>
        </div>
      </div>
      {showScrollTop && (
        <button className="scroll-to-top" onClick={scrollToTop}>
          <i className="fas fa-arrow-up"></i>
        </button>
      )}
    </footer>
  );
};

export default Footer;

